import { accordionClasses } from '@mui/material';
import { ExpandDownIcon } from '../../utils/ExpandDownIcon';
import { palette } from '../global/palette';
import { shape } from '../global/shape';
export const MuiAccordionSummary = {
    MuiAccordionSummary: {
        styleOverrides: {
            root: {
                padding: '0 24px',
                '&:focus-visible': {
                    backgroundColor: palette.grey['200'],
                    borderRadius: shape.borderRadius,
                },
                [`&.${accordionClasses.expanded}`]: {
                    minHeight: 0,
                },
            },
            content: {
                display: 'flex',
                gap: 22,
                margin: '16px 0',
                [`&.${accordionClasses.expanded}`]: {
                    marginTop: 24,
                    marginBottom: 16,
                },
            },
        },
        defaultProps: {
            expandIcon: ExpandDownIcon,
        },
    },
};
